import * as Yup from 'yup';

const validationSchema = () =>
  Yup.object().shape({
    fio: Yup.string().required('ФИО обязательно к заполнению'),
  });

export default validationSchema;
